import React from "react";
import NumberFormat from "react-number-format";
import CurrencyDisplay from "../../shared/currency-display";
import SceneSetting from "./scene-setting";

function SceneSecttings(props) {
  const {
    budget,
    onChangeSceneSettingDailyRate,
    showHideSceneSettings,
    sceneSettingsVisible,
    onChangeSceneSettingDays,
    readOnly,
    filmId,
    saving
  } = props;

  return (
    <div>
      <div className="columns subtitle is-4 mt-1">
        <div className="column">
          <h4
            className="subtitle is-4 pointer"
            onClick={() => showHideSceneSettings(!sceneSettingsVisible)}>
            <button className="button is-text is-small">
              {!sceneSettingsVisible && <i className="material-icons">add</i>}
              {sceneSettingsVisible && <i className="material-icons">remove</i>}
            </button>
            Scene Settings
          </h4>
        </div>
        <div className="column budget-header-number">
          <CurrencyDisplay
            value={budget.sceneSettingsTotal}
          />
        </div>
      </div>
      {sceneSettingsVisible && (
        <table className="table budget-table">
          <thead>
            <tr>
              <th>Name</th>
              <th className="budget-days-column">Days</th>
              <th className="budget-daily-rate-column">Daily Rate</th>
              <th className="has-text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {(budget?.sceneSettings || []).map((sceneSetting, i) => {
              return (
                <SceneSetting
                  key={i}
                  index={i}
                  sceneSetting={sceneSetting}
                  onChangeSceneSettingDailyRate={onChangeSceneSettingDailyRate}
                  days={budget.days}
                  totalScenes={budget.totalScenes}
                  maxDays={budget.days}
                  hasShootingDays={budget.hasShootingDays}
                  onChangeSceneSettingDays={onChangeSceneSettingDays}
                  readOnly={readOnly}
                  filmId={filmId}
                  saving={saving}
                />
              );
            })}
            <tr>
              <td colSpan={3}></td>
              <td className="has-text-right">
                <CurrencyDisplay
                  value={budget.sceneSettingsTotal}
                />
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}

export default SceneSecttings;
